// Função para determinar a baseURL com base no ambiente
const getBaseUrl = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Se estiver em produção (ascsiadv.com.br)
  if (window.location.hostname === 'ascsiadv.com.br' || window.location.hostname === 'www.ascsiadv.com.br') {
    return 'https://www.ascsiadv.com.br';
  }
  
  // Em desenvolvimento local
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }

  // Caso contrário (acesso via IP na rede local ou VPS) assumimos que a API está na porta 3000 do mesmo host
  return `http://${window.location.hostname}:3000`;
};

export const API_BASE_URL = getBaseUrl();

